<template lang="pug">
  include /mixins
  +b.tt-cart-campaigns-spoilers
    +e.title.tt-space_mb--2
      +b.ds-caption.--size_lg.--size_2lg-xl.--semibold.P {{ _('Ви маєте акційні товари в кошику') }}
    +e.description.tt-space_mb--2
      +b.ds-caption.--size_2md.--medium.P {{ _('Виконайте умови акції та отримайте акційну винагороду.') }}
    template(v-for="campaign in allCampaigns")
      +e.campaign-block.tt-space_mt--4(:key="campaign.descriptor_type.id")
        //- +e.campaign-description.tt-space_mb--5
          //- +b.ds-caption.--size_2md.--medium {{ campaign.descriptor_type.display }}
        +e.campaign-footer
          +e.campaign-condition.tt-space_mr--4
            +b.ds-caption.--size_2md.--medium {{ campaign.message[$options.lang] }}
          +e.campaign-link.tt-space_mt--4-till-md
            +b.ds-caption.--size_2md.--color_accent.--medium.A(
              target="_blank"
              :href="campaign.url"
            ) {{ _('Детальніше') }}
</template>
<script>

const lang = window.language

export default {
  name: 'CartCampaignSpoller',
  lang,
  props: {
    groups: {
      default: () => [],
    },
    sets: {
      default: () => [],
    },
  },

  computed: {
    allCampaigns() {
      const map = new Map();
      (this.groups || []).forEach(group => {
        const campaigns = Object.entries(group?.base?.parameters?.campaigns || {});
        campaigns.forEach(([id, campaign]) => {
          map.set(id, { ...campaign, id });
        })
      });

      return Array.from(map.values());
    },
    productProps() {
      const { relations, base, price, id } = this.product
      return {
        load: this.load,
        product: base,
        group_id: id,
        relations,
        price,
        disabled: this.$attrs.disabled,
      }
    },
  },
}
</script>
